import { Site } from "../models/site";
import axiosConfig from "./axiosConfig";

interface SitesResponse {
  sites: Site[];
}

const getSites = async (
  authToken: string,
  siteIdsChunkStr: string,
  userOrgId?: string,
  testOrgId?: string | null
): Promise<SitesResponse> => {
  const params = new URLSearchParams();
  params.append("siteIds", siteIdsChunkStr);
  if (userOrgId) params.append("userOrgId", userOrgId);
  if (testOrgId) params.append("testOrgId", testOrgId);
  const { data } = await axiosConfig.get(`/sites?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getSites;
